import type { FaireProductEntity } from "../../entity_types/product";

export const p_t89cymg9a7: FaireProductEntity = {
  token: "p_t89cymg9a7",
  type: "product",
  name: "Naruto Collab Co",
  brandToken: "b_9grp69f3nm",
  brandName: "Hydroponic",
  imageUrl:
    "https://cdn.faire.com/fastly/df0577e625f793c2cf320e42b3bf233176db8de441db2a19b26269b2858689c3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7613152c7954f6595c11dca9b78da6dcd9f3a51ef36da7b8c51807e71bbaac99.jpeg",
    "https://cdn.faire.com/fastly/ccd66c5ed9ad4d5c372dfa53cd668b7e65f939a18ab6c964c0332ab54555ede6.jpeg",
    "https://cdn.faire.com/fastly/91c30c42c6a9b20408851a1b2682379b8852b9b8ad7ba7134d196ae15f8a9e08.jpeg",
  ],
  priceDollars: 76.62,
  description:
    'Naruto Collab CO S0239 01 - Leaf Village Ninjas 7.75" Complete skateboard 7.75" with 7 plies of hard Rock Maple, 5.5" aluminum Truck with Abec 7 Bearing and Conical wheel 52mm\n\nNaruto Collab CO S0239 02 - Naruto 7.25" Complete skateboard 7.25" with 7 plies of hard Rock Maple, 5" aluminum Truck with Abec 7 Bearing and Conical wheel 52mm\n\nNaruto Collab CO S0239 02 - Naruto 8" Complete skateboard 8" with 7 plies of hard Rock Maple, 5.5" aluminum Truck with Abec 7 Bearing and Conical wheel 52mm\n\nNaruto Collab CO S0239 04 - Kakashi Complete skateboard 8.125" with 7 plies of hard Rock Maple, 5.5" aluminum Truck with Abec 7 Bearing and Conical wheel 52mm\n\nNaruto Collab CO S0239 05 - Itachi Complete skateboard 8" with 7 plies of hard Rock Maple, 5.5" aluminum Truck with Abec 7 Bearing and Conical wheel 52mm\n\nConcave: Medium.',
  tags: [],
  msrpDollars: 153.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:09.368Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
